import { render, staticRenderFns } from "./AssignPackages.vue?vue&type=template&id=13ba81cc&scoped=true"
import script from "./AssignPackages.vue?vue&type=script&lang=js"
export * from "./AssignPackages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ba81cc",
  null
  
)

export default component.exports